import React, { createContext, useState, useEffect } from 'react';

const CartContext = createContext();

const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem('cart');
    console.log(savedCart);
    try {
      return savedCart ? JSON.parse(savedCart) : [];
    } catch (error) {
      localStorage.removeItem('cart'); // Remove the invalid item
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product) => {
    console.log('Adding product to cart:', product);
    
    // Check if product already exists with same ID and size (for variants)
    const existingProduct = cart.find(item => 
      item._id === product._id && 
      item.selectedSize === product.selectedSize
    );
    
    if (existingProduct) {
      // If product exists, add the new quantity to existing quantity
      setCart(prevCart =>
        prevCart.map(item => 
          item._id === product._id && item.selectedSize === product.selectedSize
            ? { ...item, quantity: item.quantity + (product.quantity || 1) }
            : item
        )
      );
    } else {
      // If product doesn't exist, add it with the specified quantity
      setCart(prevCart => [...prevCart, { ...product, quantity: product.quantity || 1 }]);
    }
  };

  const updateQuantity = (productId, quantity) => {
    if (quantity < 1) return; // Don't allow quantity less than 1
    
    setCart((prevCart) =>
      prevCart.map((item) =>
        item._id === productId ? { ...item, quantity: parseInt(quantity) } : item
      )
    );
  };

  const removeFromCart = (id) => {
    setCart(prevCart => prevCart.filter((product) => product._id !== id));
  };

  const clearCart = () => {
    setCart([]);
  };

  // Helper function to get total items count
  const getCartItemsCount = () => {
    return cart.reduce((total, item) => total + item.quantity, 0);
  };

  // Helper function to get cart total price
  const getCartTotal = () => {
    return cart.reduce((total, item) => total + (item.price * item.quantity), 0);
  };

  return (
    <CartContext.Provider value={{ 
      cart, 
      addToCart, 
      updateQuantity, 
      removeFromCart, 
      clearCart,
      getCartItemsCount,
      getCartTotal
    }}>
      {children}
    </CartContext.Provider>
  );
};

export { CartProvider, CartContext };